// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3psrm","title":"styles_title__39Tqx"};